import { render, staticRenderFns } from "./LabelledFrameTypeSelect.vue?vue&type=template&id=15af34cb&"
import script from "./LabelledFrameTypeSelect.vue?vue&type=script&lang=js&"
export * from "./LabelledFrameTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabelledFrameTypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FrameTypeSelect: require('/opt/build/repo/storefront/components/molecules/TechSelect/FrameTypeSelect.vue').default})
